<template>
  <div class="awards container container--page-content flex flex-col gap-8 lg:gap-20">
    <div class="awards__text flex flex-col gap-4 lg:gap-6">
      <h2 class="awards__title">{{ component.awardsTitle }}</h2>
      <div class="awards__subtitle h5 text-accent" v-if="component.awardsSubtitle">{{ component.awardsSubtitle }}</div>
      <div class="awards__description text-medium-normal" v-html="component.awardsDescription"></div>
    </div>
    <div class="awards__pictures grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-10 lg:items-start xl:grid-cols[40%_60%] xl:gap-20">
      <ul class="awards__pictures-list grid grid-cols-2 gap-4 gap-y-6 items-center justify-center lg:gap-10 lg:gap-y-14">
        <li v-for="award in component.awards" :key="award.image.id" class="awards__picture-item flex items-center justify-center">
          <SharedPicture :media="award.image" class="awards__picture-image w-full max-w-[122px] mx-auto lg:max-w-[152px]" height="123" width="152" />
        </li>
      </ul>
      <SharedPicture
        v-if="component.awardsBigPicture"
        :media="component.awardsBigPicture"
        height="594"
        width="603"
        class="awards__big-picture w-full max-w-[603px] mx-auto h-auto overflow-hidden rounded-md aspect-[603/594] object-bottom lg:h-[435px] lg:w-auto lg:mr-0 lg:!ml-auto"
        imageClass="aspect-[603/594]"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { GraphQLAwards } from '~/types/graphql';

  const props = defineProps<{
    component: GraphQLAwards;
    index: number;
  }>();
</script>

<style scoped lang="scss">
  .awards {
    &__big-picture {
      &:deep(img) {
        object-fit: cover;
        object-position: bottom;
      }
    }
  }
</style>
